import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  Box,
  Checkbox,
  Text,
  VStack,
} from '@chakra-ui/react';
import { GoogleCircleIcons, SimpleCloseIcon } from '@mybridge/icons';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';

const CheckConflictsModal = ({ isOpen, onClose,selectedCalendar,calendarIcons }) => {
  // console.log(selectedCalendar,"selectedCalendar");
  const { t } = useTranslator();
  const direction = useDirection();
  
  return (
    <Modal  isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent maxWidth="502px" h={594} p="16px 0 30px 0"border='1px solid #D9D9D9' bgColor="#FFFFFF" boxShadow="0px 0px 12px 0px #00000033" borderRadius="8px">
        <ModalHeader fontSize="18px" fontWeight="bold">
        <Box cursor={'pointer'} onClick={onClose} position="absolute" right="2%" top="2%">
        <SimpleCloseIcon  width="15" height="15" color="#747474"/>
        </Box>
        </ModalHeader>
        <ModalBody>
          <VStack align="start"gap="30px" >
          <Text
                color="#5B5B5B"
                fontSize="30px"
                lineHeight="36px"
                
              >
               {t('settingsIntegration.howShouldWeCheck') || "How should we check for conflicts?"}
              </Text>
            <Box
              width="100%"
              p="8px"
              border="1px solid #E2E8F0"
              boxShadow="0px 0px 12px 0px #0000001A"
              borderRadius="md"
              display="flex"
              alignItems="center"
            >
             {calendarIcons?.[selectedCalendar?.calendarType]}
              <Text
                fontWeight="500"
                fontSize="18px"
                ml="8px"
                color="#5B5B5B"
              >
                Google {t('settingsIntegration.pluginWindows') || "plug-in (Windows)"}
              </Text>
            </Box>
            <Text fontSize="16px" color="#5B5B5B" lineHeight="19.2px" fontWeight={500}>
              {t('settingsIntegration.considerMeUnavailable') || "Consider me unavailable when outlook shows me as:"}
            </Text>
            <VStack align="start" spacing={2}>
              <Checkbox defaultChecked opacity={0.5} fontSize="18px" color="#747474" lineHeight="20px">{t('settingsIntegration.busy') || "Busy"}</Checkbox>
              <Checkbox defaultChecked fontSize="18px" color="#747474" lineHeight="20px">{t('settingsIntegration.tentative') || "Tentative"}</Checkbox>
              <Checkbox defaultChecked fontSize="18px" color="#747474" lineHeight="20px">{t('settingsIntegration.awayOutOfOffice') || "Away/ Out of office"}</Checkbox>
              <Checkbox>{t('settingsIntegration.workingElsewhere') || "Working elsewhere"}</Checkbox>
            </VStack>
            <Text fontSize="16px" lineHeight="19.2px"color="#5B5B5B">
              {t('settingsIntegration.usePluginToSelectCalendars') || "Use plug-in to select specific calendars."}
            </Text>
          </VStack>
        </ModalBody>
        <ModalFooter display="flex" justifyContent="start">
          <Button p="9px 30px" bg="#E4E6EB" borderRadius="30px" fontSize="18px" color="#3D5A80" variant="outline" {...(direction === 'rtl') ? {ml: 2} : {mr: 2}} onClick={onClose}>
            {t('buttons.cancel') || "Cancel"}
          </Button>
          <Button p="9px 30px" bg="#3D5A80" borderRadius="30px" fontSize="18px" color="#FFFFFF" variant="outline" {...(direction === 'rtl') ? {mr: 2} : {ml: 2}} >
            {t('createPost.update') || "Update"}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default CheckConflictsModal;
